// extracted by mini-css-extract-plugin
export default {"container":"styles_container__iQcLU","categories":"styles_categories__gpd+r"};